<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="flag.FlagName" label="Hashtag" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-color-picker v-model="flag.FlagColor" label="Màu sắc" class="input-group--focused"></v-color-picker>
                </v-flex>
                <v-flex lg12 md12 sm12>
                     <v-textarea v-model="flag.Note" label="Ghi chú" class="input-group--focused"></v-textarea>
                </v-flex>
                <!-- <v-flex lg12 md12 sm12>
                     <v-switch v-model="flag.IsStandby" label="Cảnh báo đơn trễ" class="input-group--focused"></v-switch>
                </v-flex> -->
            </v-layout>
        </v-card>
    </v-container>
</div>
</template>

<script>
import {
    mapState
} from "vuex";
export default {
    computed: {
        ...mapState({
            loading: state => state.flag.loading,
            flag: state => state.flag.selected
        }),
        modifyId() {
            return this.$route.params.Pid;
        }
    },
    watch: {
        modifyId() {
            this.refreshData();
        }
    },
    methods: {
        refreshData() {
            if (this.modifyId > 0) {
                this.$store.dispatch("flag/getDetail", this.modifyId);
            }
            else {
                this.$store.commit("flag/setDetail", { data: {
                        ID: 0,
                        AmountFrom: 0,
                        AmountTo: 0,
                        FeePercent: 0
                    }
                })
            }
        },
        saveData() {
            this.$store.dispatch("flag/setDetail", {
                data: {
                    ID: this.flag.ID,
                    FlagName: this.flag.FlagName,
                    FlagColor: this.flag.FlagColor ? (this.flag.FlagColor.hex || this.flag.FlagColor) : '' ,
                    Note: this.flag.Note,
                    IsStandby: this.flag.IsStandby
                },
                id: this.flag.ID
            });
            window.getApp.$emit("APP_NAVIGATE", "FlagList");
        },
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        if (this.$route.query.uid && this.$route.query.uid !== '') {
            this.flag.UID = Number(this.$route.query.uid);
        }
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>

<style>
</style>
